import React, { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";
import PricingDashboard from "./PricingDashboard";

export default function App() {
  const [session, setSession] = useState(null);
  const [checking, setChecking] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!supabase) { setChecking(false); return; }
    supabase.auth.getSession().then(({ data }) => { setSession(data.session); setChecking(false); });
    const { data: sub } = supabase.auth.onAuthStateChange((_e, s) => setSession(s));
    return () => sub.subscription.unsubscribe();
  }, []);

  const signIn = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    const { error } = await supabase.auth.signInWithPassword({ email: email.trim(), password });
    setBusy(false);
    if (error) setErr(error.message || "Sign-in failed");
  };
  const signOut = async () => { await supabase.auth.signOut(); };

  const wrap = { minHeight: "100vh", background: "#0f1117", color: "#e8eaf0", fontFamily: "-apple-system, system-ui, sans-serif" };

  if (!supabase) {
    return <div style={{ ...wrap, display: "flex", alignItems: "center", justifyContent: "center", padding: 24, textAlign: "center" }}>
      <div><h2>Backend not configured</h2><p style={{ color: "#8b90a0", maxWidth: 480 }}>Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your environment (Cloudflare Pages → Settings → Environment variables), then redeploy.</p></div>
    </div>;
  }
  if (checking) return <div style={{ ...wrap, display: "flex", alignItems: "center", justifyContent: "center" }}><span style={{ color: "#585d6e" }}>Loading…</span></div>;

  if (!session) {
    return (
      <div style={{ ...wrap, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
        <form onSubmit={signIn} style={{ background: "#161820", border: "1px solid #222536", borderRadius: 12, padding: 28, width: 340 }}>
          <h2 style={{ margin: "0 0 4px", fontSize: 18 }}>Eataly Produce Pricing</h2>
          <div style={{ fontSize: 12, color: "#8b90a0", marginBottom: 20 }}>Sign in to continue</div>
          <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required
            style={{ width: "100%", boxSizing: "border-box", padding: "10px 12px", marginBottom: 10, borderRadius: 6, border: "1px solid #2a2d3a", background: "#0f1117", color: "#e8eaf0", fontSize: 14 }} />
          <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required
            style={{ width: "100%", boxSizing: "border-box", padding: "10px 12px", marginBottom: 14, borderRadius: 6, border: "1px solid #2a2d3a", background: "#0f1117", color: "#e8eaf0", fontSize: 14 }} />
          {err && <div style={{ color: "#e05252", fontSize: 12, marginBottom: 12 }}>{err}</div>}
          <button type="submit" disabled={busy}
            style={{ width: "100%", padding: "10px", borderRadius: 6, border: "none", background: "#4a7cff", color: "#fff", fontSize: 14, fontWeight: 600, cursor: busy ? "default" : "pointer", opacity: busy ? 0.6 : 1 }}>
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    );
  }

  return (
    <div>
      <div style={{ position: "fixed", top: 10, right: 14, zIndex: 3000 }}>
        <button onClick={signOut} title={session.user?.email}
          style={{ padding: "5px 12px", borderRadius: 6, border: "1px solid #2a2d3a", background: "rgba(20,22,30,0.8)", color: "#8b90a0", fontSize: 11, cursor: "pointer" }}>
          Sign out
        </button>
      </div>
      <PricingDashboard />
    </div>
  );
}
